<template>
  
  <div>
  <v-toolbar app color="tournament1">
    <v-toolbar-title class="headline text-uppercase">
      <v-btn :to="'/'" flat dark>
        <v-icon dark left>arrow_back</v-icon>
      </v-btn>
      <span>
        {{tournament.name}}
      </span>
    </v-toolbar-title>
    
  </v-toolbar>

  <v-content>
    
    <v-img id="headerImage" :src="tournament.flavor.headerImage">
      <v-layout v-if="tournament.flavor.showTitle" 
          pa-2 column fill-height text-xs-center
          align-center justify-center row wrap>
        <v-flex shrink>
          <h1>{{tournament.name}}</h1>
        </v-flex>
      </v-layout>
    </v-img>
    
  <v-form ref="form">
    
    <v-container >
      <v-progress-circular
        indeterminate
        color="accent"
        v-show="loading"
      ></v-progress-circular>
      <div v-show="!loading">{{ error }}</div>
    </v-container>
    
  <v-container v-show="!loading && !error">

    <v-layout text-xs-center align-center justify-center row wrap>
      
      <v-flex x12 md10 lg8 text-xs-left>
        <v-card color="tournament1">
          <v-layout justify-center>
            <v-flex shrink pa-2>
              <div v-html="tournament.description"></div>  
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
  
      <v-flex xs12 />
  
      <template v-if="tournament.registrationType === 'block'" 
          v-for="(block, j) in tournament.blocks">
        <span :key="j" />
        <v-flex v-if="j % 2 == 0" lg2 hidden-md-and-down />
        <v-flex xs12 sm6 md5 lg4 :id="'block' + block.id">
          <v-card color="primary">
            <v-card-text pb-0 mb-0>
              <h2>{{ "Block " + block.name }}</h2>
              <p v-if="tournament.blocks.length > 1">{{ block.description }}</p>
            </v-card-text>
            <v-layout pb-3 align-center justify-center row wrap>
              <v-flex grow />
              <v-flex shrink>
                <v-progress-circular
                  :rotate="360"
                  :size="90"
                  :width="10"
                  :value="block.playerCount * 100 / block.maxPlayerCount"
                  color="tournament2"
                >
                  {{ block.playerCount }} / {{ block.maxPlayerCount }}
                </v-progress-circular>
              </v-flex>
              <v-flex px-2 py-1 shrink/>
              <v-flex shrink>
                <span>Freie Plätze: {{ block.maxPlayerCount - block.playerCount}}<br></span>
                <v-btn small color="tournament1" v-on:click.stop="selectBlock(block)"
                  v-if="block.playerCount < block.maxPlayerCount">Anmelden</v-btn>
                <span v-else>Der Block ist voll.</span>
              </v-flex>
              <v-flex grow />
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex v-if="j % 2 != 0" lg2 hidden-md-and-down />
      </template>
  
</v-layout>

<v-layout id="registration" v-show="registrationShown && !submit.success" text-xs-center row wrap mt-5>

  <v-flex xs12>
    <h2>Anmeldung</h2>
  </v-flex>

  <v-flex md1 lg2 hidden-sm-and-down />
  <v-flex :class="tournament.isFestival ? 'lg4 md5 xs6' : 'lg8 md10 xs12'">
    <!--<v-select v-model="form.group" :items="groups" :item-text="renderGroupItem" label="Gruppe" required></v-select>-->
    <v-select v-model="form.block" :items="blocks" :item-text="renderBlockItem" label="Block" 
        color="tournament2" required @change="selectBlock" return-object></v-select>
  </v-flex>
  <v-flex :class="tournament.isFestival ? 'lg4 md5' : ''" xs6 v-show="tournament.isFestival">
    <v-select v-model="form.shirtSize" :items="shirtSizes" label="Shirt-Größe" 
        :required="tournament.isFestival" color="tournament2"
        :rules="[(v) => !tournament.isFestival || !!v || 'Bitte wähle eine T-Shirt-Größe!']"></v-select>
  </v-flex>
  <v-flex md1 lg2 hidden-sm-and-down />
  
  <v-flex md1 lg2 hidden-sm-and-down />
  <v-flex xs12 sm6 md5 lg4>
    <v-text-field v-model="form.forename" :rules="[(v) => !!v || 'Ungültiger Vorname']" label="Vorname" 
        color="tournament2" required></v-text-field>
  </v-flex>
  <v-flex xs12 sm6 md5 lg4>
    <v-text-field v-model="form.surname" :rules="[(v) => !!v || 'Ungültiger Nachname']" label="Nachname" 
        color="tournament2" required></v-text-field>
  </v-flex>
  <v-flex md1 lg2 hidden-sm-and-down />

  <v-flex md1 lg2 hidden-sm-and-down />
  <v-flex xs6 md5 lg4>
    <v-menu ref="menu" :close-on-content-click="false" :nudge-right="40" v-model="menu" lazy transition="scale-transition" offset-y full-width min-width="290px">
      <!--<v-text-field slot="activator" label="Geburtsdatum" required :rules="[(v) => /\d{1,2}\.\d{1,2}\.\d{2,4}/.test(v) || 'Ungültiges Geburtsdatum (z.B. 25.01.1997)']" :value="formatDate"></v-text-field>-->
      <!--<v-date-picker ref="picker" v-model="form.dob" @input="dob_menu = false" :allowed-dates="getMaxDob"></v-date-picker>-->
      
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="form.dob"
          label="Geburtstag"
          readonly
          v-on="on"
          color="tournament2"
        ></v-text-field>
      </template>
      <v-date-picker
        ref="picker"
        v-model="form.dob"
        :max="new Date().toISOString().substr(0, 10)"
        min="1950-01-01"
        @change="saveDob"
        color="tournament1"
      ></v-date-picker>
      
    </v-menu>
    
  </v-flex>
  <v-flex xs6 md5 lg4>
    <v-select v-model="form.gender" :items="genders" label="Geschlecht" :rules="[(v) => !!v || 'Ungültiges Geschlecht']" 
        color="tournament2" required></v-select>
  </v-flex>
  <v-flex md1 lg2 hidden-sm-and-down />

  <v-flex md1 lg2 hidden-sm-and-down />
  <v-flex xs6 md5 lg4>
    <v-text-field v-if="tournament.isFestival"
        v-model="form.zip" :rules="zipRules" label="Postleitzahl" validate-on-blur 
        color="tournament2" required="tournament.isFestival"></v-text-field>
    <v-text-field v-if="!tournament.isFestival"
        v-model="form.club" :rules="[(v) => !!v || 'Ungültiger Verein']" label="Verein" validate-on-blur 
        color="tournament2" required="!tournament.isFestival"></v-text-field>
  </v-flex>
  <v-flex xs6 md5 lg4>
    <v-text-field v-model="form.city" :rules="[(v) => !!v || 'Ungültige Stadt']" label="Ort" 
        color="tournament2" required></v-text-field>
  </v-flex>
  <v-flex md1 lg2 hidden-sm-and-down />
  
  <v-flex md1 lg2 hidden-sm-and-down />
  <v-flex xs6 md5 lg4>
    <v-text-field v-model="form.phone" :rules="phoneRules" label="Telefonnummer" 
        color="tournament2" required></v-text-field>
  </v-flex>
  <v-flex xs6 md5 lg4>
    <v-text-field v-model="form.email" :rules="emailRules" label="E-mail" 
        color="tournament2" required></v-text-field>
  </v-flex>
  <v-flex md1 lg2 hidden-sm-and-down />
  <!-- TODO: comment box -->

  <v-flex md1 lg2 hidden-sm-and-down />
  <v-flex xs12 md10 lg8>
    <v-checkbox v-model="form.check1" value="1" label="Ich versichere hiermit, dass ich weder in einem Billardverein war, noch Mitglied eines Billardvereins bin." 
        data-vv-name="checkbox1" type="checkbox" :rules="[(v) => !!v || 'Bitte bestätige dieses Feld!']"
        required="tournament.isFestival" v-if="tournament.isFestival"
        color="tournament2"></v-checkbox>
    <v-checkbox v-model="form.check2" value="1" label="Ich trete die Rechte für Bild- und Videoauszeichnungen an den SV Motor Babalsberg ab und stimme der Turnierausschreibung zu." 
        data-vv-name="checkbox2" type="checkbox" required :rules="[(v) => !!v || 'Bitte bestätige dieses Feld!']"
        color="tournament2"></v-checkbox>
  </v-flex>

  <v-flex xs12>
    <vue-recaptcha ref="recaptcha" sitekey="6LcBEpYUAAAAAPU27y_HPlOuunCJwDfbhtu6OH7u">
    </vue-recaptcha>
    <v-btn color="tournament1" v-bind:loading="submit.loading" :disabled="submit.loading" v-on:click.stop="submitRegistration()">Anmelden</v-btn>
  </v-flex>

</v-layout>

<v-layout id="result" v-show="submit.loading != null" text-xs-center row wrap mt-1>
  <v-flex xs12>
    <!--<p class="submitResult">{{ submit.message }}</p>-->
    <v-alert :value="submit.message" :type="submit.success != null && submit.success ? 'success' : 'error'">
      {{submit.message}}
    </v-alert>
  </v-flex>

</v-layout>

</v-container>
</v-form>
</v-content>
</div>
</template>

<style type="text/css">
  @import url('https://fonts.googleapis.com/css?family=Amethysta');

  h1 {
    font-size: 50px;
    /*text-transform: uppercase;*/
    /*color: #ff8000;*/
    /*font-family: Amethysta, serif;*/
  }

  .h1-extra {
    display: table;
    margin: 0px auto;
    font-size: 0.7em;
    color: #fff;
  }

  tr {
    vertical-align: top;
  }

  td {
    padding: 10px;
  }

  .submitResult {
    font-size: 20px;
  }
  
  #headerImage {
    /*height: 100vh;*/
    width: 100vw;
  }
</style>

<script src="https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit" async defer></script>
<script>
  import Repo from '../data/repository.js'
  import Vue from 'vue'
  import Vuetify from 'vuetify'
  import VueRecaptcha from 'vue-recaptcha';

  export default {
    data: function() {
      return {
        tournamentId: this.$route.params.id,
        tournament: { flavor:{}},
        genders: ["weiblich", "männlich"],
        shirtSizes: ["XS", "S", "M", "L", "XL"],
        groups: [],
        blocks: [],
        registrationShown: false,
        menu: false,
        loading: true,
        error: "",
        submit: {
          loading: false,
          success: null,
          message: ""
        },

        form: {
          group: "",
          forename: "",
          surname: "",
          gender: "",
          dob: "",
          shirtSize: "",
          zip: "",
          city: "",
          phone: "",
          email: "",
          check1: "",
          check2: ""
        },

        emailRules: [
          (v) => /.+@.+\..+/.test(v) || 'Ungültige E-Mail-Adresse'
        ],
        phoneRules: [
          (v) => /^[\d\ -\/]{3,}$/.test(v) || 'Ungültige Telefonnummer'
        ]
      }
    },
    created: function() {
      var view = this;
      Repo.getFestival(this.tournamentId).then(function(festival) {
        if (!festival.empty) {
          view.tournamentId = festival.docs[0].id;
          view.updateTournament(festival.docs[0].data());
        } else {
          view.error = "Das gesuchte Turnier wurde nicht gefunden";
        }
        view.loading = false;
      });
    },
    computed: { 
      zipRules: function() {
        return [
          (v) => {
            console.log(this);
            return (this.tournament.flavor && this.tournament.flavor.type === "festival") ?
              /^1[0-6]\d{3}$/.test(v) || '10xxx - 16xxx' :
              /^\d{5}$/.test(v) || 'Ungültige PLZ'
          }
        ]
      }
    },
    watch: {
      menu (val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
      }
    },
    methods: {
      getMaxDob: function(val) {
        return new Date(val) < new Date();
      },
      renderBlockItem: function(block) {
        return block.name;
      },
      selectBlock: function(block) {
        this.registrationShown = true;
        this.form.block = block;
        this.resetSubmit();
        var view = this;
        setTimeout(function() {
          view.$vuetify.goTo("#registration");
        }, 100);
      },
      submitRegistration: function() {
        this.resetSubmit();
        var ok = this.$refs.form.validate();
        if (ok) {
          this.submit.loading = true;
          Repo.register(this.tournament.id, this.form, (success, result) => {
            if (!success) {
              this.submit.message = "Es ist ein Fehler aufgetreten.";
            }
            else {
              this.submit.message = "Vielen Dank. Wir haben deine Anmeldung erhalten und senden dir eine E-Mail mit weiteren Informationen zu.";
              this.updateTournament(result.data);
            }
            this.submit.success = success;
            this.submit.loading = false;
          });
        } else {
          // TODO: notify user that there's something invalid
          console.error("form is not valid");
          this.submit.success = false;
          this.submit.message = "Bitte überprüfe deine Eingaben";
        }
      },
      resetSubmit: function() {
        this.submit.message = "",
        this.submit.success = null;
      },
      saveDob: function (date) {
        this.$refs.menu.save(this.form.dob);
      },
      updateTournament: function(doc) {
        var view = this;
        
        view.tournament = doc;
        view.$vuetify.theme.tournament1 = doc.flavor.color1;
        view.$vuetify.theme.tournament2 = doc.flavor.color2;
        view.tournament.isFestival = view.tournament.flavor.type === 'festival';
        view.tournament.id = view.tournamentId;
        
        var blockCount = Object.keys(view.tournament.blocks).length;
        Object.entries(view.tournament.blocks).forEach(function(value) {
          var block = value[1];
          view.blocks.push(block);
          if (block.playerCount < block.maxPlayerCount) {
            view.blocks.push(block);
          }
        });
      },
      init: function() {
        Repo.init(this.tournamentId);
      }
    },
    components: {
      VueRecaptcha
    }
  }
</script>

<style>
</style>
